import React from 'react';
import { ToothPeriodontalItem } from '../../../../graphql/graphql';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalItem.module.scss';
import { joinClasses } from '../../../../Utils/className.util';
import useTranslation from '../../../../Hooks/useTranslation';
import DENTModalOverviewGeneralPeriodontalItemIssues from '../DENTModalOverviewGeneralPeriodontal/DENTModalOverviewGeneralPeriodontalItemIssues';

export interface PeriodontalItemProps {
	title: string;
	periodontalItem: ToothPeriodontalItem;
	onClick: (input: any) => void;
	isSelected?: boolean;
}

const DENTModalOverviewGeneralPeriodontalItem = ({
	title,
	periodontalItem,
	onClick,
	isSelected,
}: PeriodontalItemProps) => {
	const { t } = useTranslation();

	const { margin, depth, ...issues } = periodontalItem;
	const showWarning = depth && depth > 4;

	return (
		<div
			className={joinClasses([
				styles.box,
				showWarning ? styles.warning : '',
				isSelected ? styles.selected : '',
			])}
			onClick={onClick}>
			<div className={styles.depth}>{depth ?? '-'}</div>
			<div className={styles.margin}>{margin ?? '-'}</div>
			<p className={styles.title}>{t(title)}</p>
			<DENTModalOverviewGeneralPeriodontalItemIssues issues={issues} />
		</div>
	);
};

export default DENTModalOverviewGeneralPeriodontalItem;
